module.exports = __webpack_public_path__ + "static/media/dice-six.b9e1d36f.svg";